/**
 * The RTE toolbar and the component toolbar (move, clone, delete) are both
 * attached to the same element. On small elements they end up on top of each
 * other, so the RTE toolbar is moved one component-toolbar-height further
 * away from the element.
 */
export function adjustRteToolbarPosition(pos, componentToolbar) {
  const compHeight = componentToolbar?.height || 0
  const compWidth = componentToolbar?.width || 0

  if (!pos?.elRect || !compHeight || !compWidth) {return pos}

  const { elRect, targetHeight, targetWidth, canvasOffsetTop } = pos
  const compLeft = elRect.width - compWidth
  const rteOverlapsHorizontally = pos.left + targetWidth > compLeft && pos.left < elRect.width

  if (!rteOverlapsHorizontally) {return pos}

  const isAbove = pos.top === -targetHeight
  const componentToolbarIsAbove = canvasOffsetTop >= compHeight

  if (isAbove) {
    pos.top = canvasOffsetTop >= targetHeight + compHeight
      ? pos.top - compHeight
      : elRect.height
  } else if (!componentToolbarIsAbove) {
    pos.top += compHeight
  }

  return pos
}

const rteToolbarPlugin = editor => {
  editor.on('rteToolbarPosUpdate', pos => {
    const el = editor.Canvas.getToolbarEl()
    const visible = el && el.offsetWidth > 0 && el.offsetHeight > 0

    adjustRteToolbarPosition(pos, visible ? { width: el.offsetWidth, height: el.offsetHeight } : null)
  })
}

export default rteToolbarPlugin
